export default "__VITE_ASSET__0dUJKIGw__"